module.exports = __webpack_public_path__ + "static/img/icon10.6294c7b5.png";